export const ATENDIDA = 0;
export const DESATENDIDA = 1;

export const DESATENDIDA_STATE = {
  ATENDIDA,
  DESATENDIDA
};

export default {
  methods: {
    configureConsequence(
      consequence,
      configurations,
      loadConfiguration = () => {}
    ) {
      const configurationOriginal = JSON.parse(this.decode(consequence.configuracion));
      const keys = Object.entries(configurations);
      keys.forEach(([key, valor]) => {
        const configuration = {
          id: key,
          type: valor.tipo,
          title: valor.titulo,
          value: configurationOriginal[key] || valor.valor || valor.default || '',
        };
        loadConfiguration(configuration, key, valor);
      });
    }
  }
};
